import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import verify1 from "../assets/VerificationSuccessful-01.jpg";
import verify2 from "../assets/VerificationSuccessful-02.png";
import { getProductById } from "../services/apiService";
import "../styles/warranty.css";

const VerificationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [productid, setProductId] = useState(null);
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [verifiedProduct, setVerifiedProduct] = useState(null);

  const scrollToProductTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Get verified product data from navigation state  
  useEffect(() => {
    const state = location.state?.verifiedProduct;
    if (state) {
      setVerifiedProduct(state);
      setProductId(state.productid);
    }
  }, [location]);

  useEffect(() => {
    if (!productid) return;
    setLoading(true);
    getProductById(productid)
      .then((res) => {
        const p = { ...res.data[0], qty: 0 };
        setProduct(p);
        setMainImage(p.image1);

        // Scroll to top when product loads
        setTimeout(scrollToProductTop, 100);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching product:", err);
        setLoading(false);
      });
  }, [productid]);

  return (
    <>
      <div
        style={{
          maxWidth: "1287px",
          margin: "0 auto",
          padding: "40px 20px",
        }}
      >
        {/* <NavLink 10004501
        to="/Home"
        style={{
          display: "inline-block"  ,
          marginBottom: "30px",
          padding: "12px 24px",
          background: "#005487",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "8px",
          fontWeight: "600",
          fontSize: "16px",
        }}
      >
        ← Back
      </NavLink> */}
        <div>
          <img
            src={verify1}
            alt="Verification Successful 1"
            style={{
              flex: "1 1 500px", 
              maxWidth: "100%",
              minWidth: "300px",
              width: "100%",
              height: "auto",
              borderRadius: "12px",
            }}
          />
          <div className="mobile-warranty-btn text-center">
            <button
              type="button"
              className="btn btn-primary btn-register-warranty"
              onClick={() =>
                navigate("/register-warranty", { state: { verifiedProduct } })
              }
            >
              Register Warranty
            </button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            padding: "0px",
            gap: "0px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Display Verification Status */}
          {/* {verifiedProduct && (
          <div className="col-md-8 mb-4">
            <div
              style={{
                background:
                  verifiedProduct.type === "Success" ? "#d4edda" : "#f8d7da",
                border:
                  verifiedProduct.type === "Success"
                    ? "1px solid #c3e6cb"
                    : "1px solid #f5c6cb",
                borderRadius: "8px",
                padding: "20px",
                textAlign: "center",
              }}
            >
              <h4
                style={{
                  color:
                    verifiedProduct.type === "Success" ? "#155724" : "#721c24",
                  marginBottom: "10px",
                }}
              >
                {verifiedProduct.msg}
              </h4>
              <p
                style={{
                  color:
                    verifiedProduct.type === "Success" ? "#155724" : "#721c24",
                  marginBottom: 0,
                }}
              >
                Hologram Number: {verifiedProduct.hologram_number}
              </p>
            </div>
          </div>
        )} */}

          {/* Display Product Details from Verified Response */}

          {verifiedProduct && (
            <div className="col-md-8 mb-4">
              <div className="verify-product-container">
                {/* Image Section */}
                <div className="verify-product-image">
                  <img
                    src={mainImage || product?.image1}
                    alt={product?.displaymodelno || "Product"}
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      maxHeight: "300px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                {/* Product Details Section */}
                <div className="verify-product-info">
                  <h4
                    style={{
                      marginBottom: "20px",
                      color: "#005487",
                      // borderBottom: "1px solid #eee",
                      paddingBottom: "10px",
                    }}
                  >
                    Product Details
                  </h4>

                  <div className="verify-product-row">
                    <span>Product ID</span>
                    <span>{verifiedProduct.productid}</span>
                  </div>

                  <div className="verify-product-row">
                    <span>Model No</span>
                    <span>{verifiedProduct.modelno}</span>
                  </div>

                  <div className="verify-product-row">
                    <span>Category</span>
                    <span>{verifiedProduct.category}</span>
                  </div>

                  <div className="verify-product-row">
                    <span>Subcategory</span>
                    <span>{verifiedProduct.subcategory}</span>
                  </div>

                  <div className="verify-product-row">
                    <span>Brand</span>
                    <span>{verifiedProduct.brand}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Display Warranty Details */}
          {/* {verifiedProduct && (
          <div className="col-md-8 mb-4">
            <div className="product-details-card">
              <div className="product-details-header">
                {product && (
                  <div className="col-md-8 mb-4">
                    <div className="product-details-card">
                      <div className="product-details-image">
                        <img
                          src={mainImage || product.image1}
                          alt={product.displaymodelno}
                          style={{ maxHeight: "300px", objectFit: "contain" }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <h4>Warranty Details</h4>
              </div>
              <div className="product-details-body">
                <div className="product-details-info">
                  <div className="product-details-row">
                    <span className="detail-label">Warranty Type</span>
                    <span className="detail-value">
                      {verifiedProduct.warrent_type?.join(", ") ||
                        "Not Available"}
                    </span>
                  </div>
                  <div className="product-details-row">
                    <span className="detail-label">Warranty Days</span>
                    <span className="detail-value">
                      {verifiedProduct.warrent_days} days
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

          {/* Display Product Image if Available */}

          <div className="desktop-register-btn col-md-8 mb-4 text-center">
            <button
              type="button"
              className="btn btn-primary btn-register-warranty"
              onClick={() =>
                navigate("/register-warranty", { state: { verifiedProduct } })
              }
            >  
              Register Warranty
            </button>
          </div>

          <img
            src={verify2}
            alt="Verification Successful 2"
            style={{
              flex: "1 1 500px",
              maxWidth: "100%",
              width: "100%",
              height: "auto",
              borderRadius: "12px",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default VerificationSuccess;
